export { LightboxImage, LightboxImageProps } from './LightboxImage';
